import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {ResponseType} from "./ResponseType";
import {getMessage} from "../util";

const NotFound = (props:ResponseType) => {
    return(
        <Row className={"justify-content-center flex-column mx-auto"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"justify-content-center mx-auto"}>
                <p className={"lead"}>{getMessage('not_found', props.messages)}</p>
            </Col>
            <Col xs={12} sm={5} md={4} lg={3} className={"text-center justify-content-center mx-auto d-flex flex-column"}>
                <a className="btn btn-dark EvColorBlue m-1 text-decoration-none fw-bold" role={"button"} target={"_blank"} href="https://evoting.typeform.com/to/iwLCMKqh">
                    {getMessage('formulario', props.messages)}
                </a>
                <Button className="EvColorGrisLight m-1" onClick={props.volver}
                        variant="light">{getMessage('ask_again', props.messages)}</Button>
            </Col>
        </Row>
    )
}

export default NotFound;